import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from "../../config/AxiosInstance";


//-----------------transaction-List-Api---------------------
export const transactionListApi = async (data) => {
  const endPoint = 'user/subscription/transaction/list' + '?' + new URLSearchParams(data).toString()
  return await axios.get(endPoint, setJwtToken());
};

// ----------------subscription-History-List-Api------------------------
export const subscriptionHistoryListApi = async () => {
  return await axios.get("/user/subscription/list", setJwtToken());
};
// ----------------cancel-Subscription-Api------------------------
export const cancelSubscriptionApi = async (id) => {
  const endPoint = 'user/subscription' + '?' + new URLSearchParams(id).toString()
  return await axios.delete(endPoint, setJwtToken());
};
